export default __webpack_public_path__ + "static/media/page-visited-toolbox.149ef9eb.svg";